<template>
   <b-modal
   id="plant-modal"
   :hide-header-close="true"
   :ok-title="$t('send')"
   :cancel-title="$t('cancel')"
   :title="$t('report_comments_title')"
   size="lg"
   @ok="onSubmit"
   @cancel="onReset"
   @shown="onShown">
    <b-alert v-if="show_message" :variant="message_variant" show>{{ $t(message) }}</b-alert>

    <div class="plant-report-modal__intro">
      <p>{{ $t('report_modal_intro') }}</p>
      <ul class="plant-report-modal__list">
        <li>{{ $t('report_reason_toxicity') }}</li>
        <li>{{ $t('report_reason_missing') }}</li>
        <li>{{ $t('report_reason_photo') }}</li>
        <li>{{ $t('report_reason_source') }}</li>
      </ul>
    </div>

    <div v-if="selected_plant" class="plant-report-modal__plant">
      {{ $t('plant') }}<br>
      <b>{{ selected_plant.scientific_name }} / {{ plantDisplayName }}</b>
    </div>
    <div v-else class="plant-report-modal__plant plant-report-modal__plant--general">
      {{ $t('report_general_plant') }}
    </div>

    <b-form class="plants-report-form" @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group
        id="input-group-email"
        label-for="input-email"
        :label="$t('email')"
      >
        <b-form-input
          id="input-email"
          v-model="form.email"
          type="email"
          :placeholder="$t('email_placeholder')"
          required
        ></b-form-input>
      </b-form-group>

      <div class="plants-hp" aria-hidden="true">
        <label for="input-fax">Website</label>
        <input
          id="input-fax"
          name="fax"
          v-model="form.website"
          type="text"
          tabindex="-1"
          autocomplete="off"
        >
      </div>

      <b-form-group id="input-group-description" :label="$t('description')" label-for="input-description">
        <b-form-textarea
          id="input-description"
          type="textarea"
          v-model="form.description"
          rows="5"
          :placeholder="$t('description_placeholder')"
          required
        ></b-form-textarea>
        <b-form-text>{{ $t('description_max_characters') }}</b-form-text>
      </b-form-group>

      <b-form-checkbox
      id="checkbox-agreement"
      v-model="form.agreement"
      name="checkbox-agreement"
      >
        <span class="plant-report-modal__agreement">
          <template v-if="lang === 'en'">
            I accept the <a :href="termsUrl" target="_blank" rel="noopener noreferrer" @click.stop>Terms of Service</a>
            and confirm I have read the <a :href="privacyUrl" target="_blank" rel="noopener noreferrer" @click.stop>Privacy Policy</a>.
          </template>
          <template v-else>
            Akceptuję <a :href="termsUrl" target="_blank" rel="noopener noreferrer" @click.stop>Regulamin</a>
            oraz potwierdzam zapoznanie się z <a :href="privacyUrl" target="_blank" rel="noopener noreferrer" @click.stop>Polityką prywatności</a>.
          </template>
        </span>
      </b-form-checkbox>
    </b-form>

    <p class="plant-report-modal__alt">
      {{ $t('report_modal_alt') }}
      <a href="mailto:kontakt@plants4pets.pl">kontakt@plants4pets.pl</a>
    </p>
  </b-modal>
</template>

<script>
import { usePlantStore } from '@/stores/plant-store'
import { mapState } from 'pinia'

export default {
  props: {
  },
  data() {
      return {
        form: {
          email: '',
          description: '',
          agreement: false,
          website: '',
          form_ts: Math.floor(Date.now() / 1000),
        },
        show: true,
        show_message: false,
        message_variant: '',
        message: ''
      }
  },
  computed: {
    ...mapState(usePlantStore, ['selected_plant', 'lang']),
    plantDisplayName () {
      if (!this.selected_plant) {
        return ''
      }
      if (this.lang === 'en') {
        return this.selected_plant.name_en || this.selected_plant.name
      }
      return this.selected_plant.name_pl || this.selected_plant.name
    },
    termsUrl () {
      return this.lang === 'en' ? '/en/regulamin' : '/regulamin'
    },
    privacyUrl () {
      return this.lang === 'en' ? '/en/privacy-policy' : '/polityka-prywatnosci'
    }
  },
  methods: {
    onShown () {
      this.form.website = ''
      const now = Math.floor(Date.now() / 1000)
      if (!this.form.form_ts || (now - this.form.form_ts) > 5 * 60 * 60) {
        this.form.form_ts = now
      }
    },
    async onSubmit (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.message_variant = 'danger'
      let is_error = false
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const is_email = re.test(this.form.email)
      if (!is_email) {
        this.message = 'error_email'
        is_error = true
      }
      if (!this.form.description) {
        this.message = 'empty_description'
        is_error = true
      }
      if (!this.form.agreement) {
        this.message = 'empty_agreement'
        is_error = true
      }
      if (is_error) {
        this.show_message = true
        return
      }

      const store = usePlantStore()
      const status = await store.postReport({
        email: this.form.email,
        description: this.form.description,
        plant: this.selected_plant ? this.selected_plant.id : null,
        website: this.form.website,
        form_ts: this.form.form_ts,
      })
      if (status === 201) {
        this.message = 'create_report_success'
        this.message_variant = 'success'
        this.form.email = ''
        this.form.description = ''
        this.form.agreement = false
        this.form.website = ''
        this.show_message = true
        this.$nextTick(() => {
          this.$bvModal.hide('plant-modal')
        })
        return
      }

      this.message = 'create_report_error'
      this.show_message = true
    },
    onReset() {
      this.form.email = ''
      this.form.description = ''
      this.form.agreement = false
      this.form.website = ''
      this.show = false
      this.show_message = false
      this.message_variant = ''
      this.message = ''

      const store = usePlantStore()
      store.selected_plant = null
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>
<style>
  .custom-control-label{
    display: inline !important
  }
  .plant-report-modal__intro {
    margin-bottom: 0.85rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #444;
  }
  .plant-report-modal__intro p {
    margin: 0 0 0.5rem;
  }
  .plant-report-modal__list {
    margin: 0 0 0 1.1rem;
    padding: 0;
  }
  .plant-report-modal__plant {
    margin-bottom: 0.85rem;
    padding: 0.65rem 0.75rem;
    background: #fff8ec;
    border: 1px solid #e8dcc8;
    border-radius: 6px;
    font-size: 0.875rem;
  }
  .plant-report-modal__plant--general {
    color: #666;
  }
  .plant-report-modal__alt {
    margin: 0.85rem 0 0;
    font-size: 0.8125rem;
    color: #666;
  }
  .plant-report-modal__agreement {
    font-size: 0.8125rem;
    line-height: 1.45;
  }
  .plant-report-modal__agreement a {
    color: #b45309;
    font-weight: 600;
    text-decoration: underline;
  }
</style>
